import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import DefaultLayout from '../../components/DefaultLayout';
import { toggleMenu, toggleStatusBar } from './reducer';
import { actions as applicationActions } from '../Application';

const mapStateToProps = state => {
  const getInactivatedByuser = () => {
    const id = state.application.application.inactivatedBy;

    const inactivateApplicant = state.application.application.applicants.filter(
      applicant => applicant.id === id
    );

    const inactivateName = inactivateApplicant[0].members.member1.name;

    return inactivateName || `part med annons ID: ${id}`;
  };

  const getCanBeActivated = () => {
    const { inactivatedBy } = state.application.application;
    const { id } = state.application.currentApplicant;

    return id === inactivatedBy;
  };

  return {
    menuOpen: state.menu.menuOpen,
    isStartPage: state.router.location.pathname === '/',
    isInactivated: state.application.application.status === 'INACTIVE',
    inactivatedBy: () => getInactivatedByuser(),
    canBeActivated: () => getCanBeActivated(),
    makeSpaceForNotificationBar: state.notificationBar.shouldShow,
    statusBarOpen: state.menu.statusBarOpen,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleMenu,
      toggleStatusBar,
      reactivateApplication: applicationActions.reactivateApplication,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);



// WEBPACK FOOTER //
// ./src/features/DefaultLayout/index.js